module.exports = __webpack_public_path__ + "img/broom.324be0e2.svg";